export function generateValidQueryStrings(params) {
    const validQueryStrings = [];
    for (const property in params) {
        if (params[property] !== undefined && params[property] !== null &&
            (typeof params[property] !== "string" || params[property].trim() !== "")) {
            validQueryStrings.push({key: property, value: params[property]});
        }
    }
    return validQueryStrings;
}

export function generateQueryStringURL(baseURL, params) {
    const validQueryStrings = generateValidQueryStrings(params);
    for (let i = 0; i < validQueryStrings.length; i++) {
        if (!i) {
            baseURL += "?";
        }
        baseURL += `${validQueryStrings[i].key}=${validQueryStrings[i].value}`;
        if (validQueryStrings.length - 1 !== i) {
            baseURL += "&";
        }
    }
    return baseURL;
}